var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwoFactorAuthenticationIllustrationDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "668px",
    height: "378px",
    viewBox: "0 0 668 378",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "two-step-illustration") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "81.1767625%",
    x2: "50%",
    y2: "-34.5130789%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8C19",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC967",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "62.1100647%",
    y1: "31.3809088%",
    x2: "62.1100647%",
    y2: "-27.4779882%",
    id: "linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8FDFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AAD4FF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M13.7499769,0.112197414 L44.4230025,0.112197414 C45.5912952,0.112197414 46.5383835,1.05230265 46.5383835,2.21198123 L46.5383835,7.98638672 C54.2947808,17.6978869 58.1729794,27.409387 58.1729794,37.1208871 C58.1729794,46.5332743 54.861178,55.9456614 48.2375752,65.3580486 C47.84186,65.9203654 47.1944026,66.2553876 46.5033847,66.2553876 L11.6695856,66.2553876 C10.9785673,66.2553876 10.3311095,65.9203608 9.93539854,65.3580405 C3.31179951,55.9456561 0,46.5332716 0,37.1208871 C0,27.5926228 3.73323214,18.0643586 11.1996964,8.53609427 L11.6345959,7.98638672 L11.6345959,2.21198123 C11.6345959,1.05230265 12.5816842,0.112197414 13.7499769,0.112197414 Z",
    id: "path-3"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uD83D\\uDCDD-Pages-New",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Two-Step-Verification",
    transform: "translate(-143.000000, -351.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "two-step-illustration",
    transform: "translate(143.500000, 351.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-59",
    transform: "translate(0.500000, 25.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M618.526138,151.035173 C627.140362,139.536676 643.451208,137.193821 654.957432,145.80226 C666.348594,154.324614 668.760281,170.385361 660.449003,181.862704 L660.193862,182.209087 L591.940548,273.315438 C583.247258,284.919475 567.101647,287.861519 554.884153,280.138844 L554.51514,279.901557 L511.547615,251.797802 L468.225949,314.851611 C460.171473,326.574554 444.212167,329.640265 432.396409,321.811517 L432.039637,321.570945 C420.308816,313.521878 417.241044,297.57329 425.075054,285.765467 L425.315787,285.408934 L482.085705,202.782769 C490.542899,190.473688 507.208324,187.081514 519.793635,195.029017 L520.173747,195.273324 L563.939667,223.898935 L618.526138,151.035173 Z",
    id: "Path",
    fill: "#7367F0",
    fillRule: "nonzero",
    opacity: 0.0845424107
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.1153,3.19214974 C397.299411,0.0191451295 401.649977,-0.787841133 404.832561,1.38969547 C407.973269,3.53858029 408.802856,7.79093273 406.725119,10.9518599 L406.640457,11.0777074 L389.630839,35.7863247 C387.1372,39.2682989 382.31224,40.1070543 378.788263,37.6983276 L378.662966,37.6109199 L368.893802,30.6568028 L358.306345,47.4286388 C356.276976,50.6432728 352.046959,51.6382772 348.796297,49.6925294 L348.668497,49.6141945 C345.444158,47.5909337 344.44615,43.3736497 346.397772,40.1327719 L346.476343,40.0053569 L360.517345,17.7636272 C362.830425,14.0995789 367.684813,12.9987589 371.359923,15.3048769 L371.552126,15.4294198 L371.740605,15.5594957 L381.714777,22.6597012 L395.1153,3.19214974 Z",
    id: "Path",
    fill: "#7367F0",
    fillRule: "nonzero",
    opacity: 0.0845424107
  }), /*#__PURE__*/React.createElement("path", {
    d: "M583.235037,116.44065 L583.235037,100.131628 L583.235037,100.131628 L599.5567,100.131628 C600.937412,100.131628 602.0567,99.0123395 602.0567,97.6316277 L602.0567,90.0891569 C602.0567,88.708445 600.937412,87.5891569 599.5567,87.5891569 L583.235037,87.5891569 L583.235037,87.5891569 L583.235037,71.1583627 C583.235037,69.7776508 582.115748,68.6583627 580.735037,68.6583627 L573.062283,68.6583627 C571.681571,68.6583627 570.562283,69.7776508 570.562283,71.1583627 L570.562283,87.5891569 L570.562283,87.5891569 L554.24062,87.5891569 C552.859908,87.5891569 551.74062,88.708445 551.74062,90.0891569 L551.74062,97.6316277 C551.74062,99.0123395 552.859908,100.131628 554.24062,100.131628 L570.562283,100.131628 L570.562283,100.131628 L570.562283,116.44065 C570.562283,117.821362 571.681571,118.94065 573.062283,118.94065 L580.735037,118.94065 C582.115748,118.94065 583.235037,117.821362 583.235037,116.44065 Z",
    id: "+",
    fill: "#00CFE8",
    opacity: 0.070265997
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.1480886,18.5370465 C130.622467,18.5370465 168.297394,56.1866716 168.297394,102.629838 C168.297394,149.073004 130.622467,186.722629 84.1480886,186.722629 C37.6737106,186.722629 -0.00121671615,149.073004 -0.00121671615,102.629838 C-0.00121671615,56.1866716 37.6737106,18.5370465 84.1480886,18.5370465 Z M84.1480886,60.1499741 C60.6713409,60.1499741 41.6396766,79.1688569 41.6396766,102.629838 C41.6396766,126.090819 60.6713409,145.109701 84.1480886,145.109701 C107.624836,145.109701 126.656501,126.090819 126.656501,102.629838 C126.656501,79.1688569 107.624836,60.1499741 84.1480886,60.1499741 Z",
    id: "Oval",
    fill: "#00CFE8",
    opacity: 0.0739397321
  })), /*#__PURE__*/React.createElement("g", {
    id: "Illustration",
    transform: "translate(328.000000, 189.000000) scale(-1, 1) translate(-328.000000, -189.000000) translate(129.500000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.11136,236 L172,236 L172,236 L172,354 C172,356.209139 170.209139,358 168,358 L27,358 C24.790861,358 23,356.209139 23,354 L23,260.11136 C23,246.795024 33.7950236,236 47.11136,236 Z",
    id: "Rectangle",
    fill: "#374057"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#374057",
    points: "37 334 144 334 144 358 37 358"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#374057",
    points: "176.173488 360 183 377 150 377 155.718701 360"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#374057",
    points: "63.1734884 358 70 377 37 377 42.7187006 358"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#374057",
    points: "287.173488 360 294 377 261 377 266.718701 360"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.577981,109.894413 L172,109 L172,109 L172,248 L108,248 L108,133.999873 C108,120.891377 118.472693,110.184392 131.577981,109.894413 Z",
    id: "Rectangle",
    fill: "#283046"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.11136,109 L271.16,109 C283.221899,109 293,118.778101 293,130.84 L293,248.2528 C293,249.217752 292.217752,250 291.2528,250 L120,250 L120,250 L120,133.11136 C120,119.795024 130.795024,109 144.11136,109 Z",
    id: "Rectangle",
    fill: "#454E67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269,109 L271.16,109 C283.221899,109 293,118.778101 293,130.84 L293,234.2528 C293,235.217752 292.217752,236 291.2528,236 L245,236 L245,236 L245,133 C245,119.745166 255.745166,109 269,109 Z",
    id: "Rectangle",
    fill: "#374057"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6,250 L165,250 L165,250 L165,342 L37,342 L37,262.6 C37,255.641212 42.6412122,250 49.6,250 Z",
    id: "Rectangle",
    fill: "#454E67"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Wom1.4",
    transform: "translate(115.500000, 196.000000) scale(-1, 1) translate(-115.500000, -196.000000) translate(0.000000, 15.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Head",
    transform: "translate(46.125178, 0.659181)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.1051597,80.6123326 C-3.09081861,76.5839116 -4.22332509,52.8399242 8.85032968,44.6035349 C-4.63240015,16.1717093 26.5465327,-12.0573971 47.9038203,5.35194933 C61.9051694,-0.676983469 73.5404723,22.84915 60.5121178,41.1210469 C65.974672,72.4944263 54.8572728,80.60413 34.8164382,80.948642 L14.1051597,80.6123326 Z",
    id: "Path",
    fill: "#42474F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.319095,74.9416005 C14.319095,74.9416005 22.6841189,72.9661099 22.9743151,59.1778958 C23.2645113,45.3896817 23.0607974,40.6830906 23.0607974,40.6830906 L41.4864719,40.3486317 C41.4864719,40.3486317 41.6873236,55.7153751 41.6901858,61.2735806 C41.6978731,76.2021588 52.0382806,74.9416005 52.0382806,74.9416005 C52.0382806,74.9416005 49.888709,87.0462506 33.1928181,87.9906621 C20.1570508,88.7291783 14.319095,74.9416005 14.319095,74.9416005 Z",
    id: "Path",
    fill: "#EDC2C2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7655636,33.7978573 C10.5459002,33.4778981 11.8866228,45.5825771 20.4253098,45.5661442 C20.4253098,45.5661442 25.3847095,62.7615582 42.603109,62.7615582 C56.5866698,62.7615582 57.4963242,42.7199841 57.6231649,38.7219433 C57.7596148,34.459042 57.7769112,20.4542996 57.7769112,20.4542996 L18.445579,20.4359333 L18.7655636,33.7978573 Z",
    id: "Path",
    fill: "#FFD7D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.5892981,49.8390124 C39.5892981,49.8390124 42.410276,54.4286938 47.9384367,52.7854633",
    id: "Path",
    stroke: "#F77B7B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    transform: "translate(43.763867, 51.489890) rotate(-18.000000) translate(-43.763867, -51.489890) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.983927,55.3179293 C43.2799216,55.8653019 44.5090664,55.8655575 45.5845074,55.237077",
    id: "Path",
    stroke: "#F49494",
    strokeLinecap: "round",
    transform: "translate(43.784217, 55.478022) rotate(2.000000) translate(-43.784217, -55.478022) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1418773,40.5099276 C19.6610038,38.6370145 19.4341765,37.0020453 17.5857281,36.2572924",
    id: "Path-8",
    stroke: "#F77B7B",
    strokeLinecap: "round",
    transform: "translate(18.484904, 38.383610) rotate(-13.000000) translate(-18.484904, -38.383610) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4650662,32.3022682 C17.4650662,32.3022682 21.9703729,38.3836885 22.8829772,38.4159896 C23.7955815,38.4482906 24.1151442,30.5067955 24.1151442,30.5067955 C29.6417758,30.0820796 43.6285358,27.2802288 47.0571173,20.7529404 C49.4548234,26.5122443 54.038299,29.0704173 57.0498053,28.5791687 L57.6205886,40.814814 L59.0262693,16.2159671 L16.363102,16.2159671 L17.4650662,32.3022682 Z",
    id: "Path",
    fill: "#42474F"
  })), /*#__PURE__*/React.createElement("g", {
    id: "LLeg",
    transform: "translate(53.010188, 186.656250)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M91.6215451,132.094648 C91.6215451,132.094648 84.2475388,147.076926 90.2925563,151.798208 C96.3466642,156.520404 112.338229,165.369493 112.338229,165.369493 L69.9712829,162.691082 L79.388784,130.015199 L91.6215451,132.094648 Z",
    id: "Path",
    fill: "#FFD7D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.0693695,146.352685 C76.1601274,146.598671 73.9272337,153.679807 78.4541792,154.218415 C82.9720345,154.756109 85.1678588,148.047283 90.2947609,150.174153 C95.4216631,152.301022 114.119724,163.297229 114.856034,167.792643 C115.601435,172.287143 108.634994,173.609695 99.0811388,172.594661 C89.527284,171.579626 87.7663723,168.160512 80.5941635,169.537667 C73.4310449,170.913907 68.0649272,168.720028 68.3012738,163.454651 C68.5376203,158.190188 71.9786115,146.107613 74.0693695,146.352685 Z",
    id: "Path",
    fill: "#2B2E35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.6332315,151.265018 L91.4517001,153.047399 C91.1465507,153.507728 91.2723483,154.12827 91.7326768,154.43342 C91.7531981,154.447023 91.7742148,154.459864 91.7956839,154.471916 L105.016084,161.893495 C105.307837,162.057277 105.662168,162.064299 105.960181,161.912205 L108.114925,160.812505 L108.114925,160.812505 C105.033429,158.567329 102.513612,156.880401 99.7290745,155.223998 C97.5913502,153.952357 95.2246279,152.641367 92.6332315,151.265018 Z",
    id: "Path-14",
    fillOpacity: 0.54097465,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.8001846,0.0447084073 C40.6265301,0.620809069 112.014356,16.5043816 124.984316,19.2028895 C137.954275,21.9013974 148.919537,36.5032153 139.029342,53.4113125 C127.921055,72.3915432 99.2596377,126.294958 92.3008684,138.446122 C88.8565689,144.460439 71.4806574,141.088359 75.5621805,130.993783 C83.170872,112.175682 86.7043558,64.9028193 106.102953,47.6664362 C106.102953,47.6664362 40.8656837,59.0879234 12.6859026,46.0049517 C-7.79443512,36.4947186 -3.16121368,-1.34799208 27.8001846,0.0447084073 Z",
    id: "Path",
    fill: "#33373E"
  })), /*#__PURE__*/React.createElement("g", {
    id: "LArm",
    transform: "translate(90.694523, 79.640000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80.9961101,30.7619065 C80.9961101,30.7619065 80.8511719,20.2633051 84.5018008,14.7766859 C88.1524296,9.29006679 88.2973678,3.46207425 91.0602506,3.65284174 C93.8231335,3.84360923 91.0874265,17.3899267 91.0874265,17.3899267 C91.0874265,17.3899267 94.5931173,16.0426884 97.1114171,14.3385596 C99.6297169,12.6344309 107.266144,4.23335908 109.050695,5.72207574 C112.076278,8.25864446 107.202734,22.5671192 104.548554,25.4277188 C101.885316,28.2892312 87.3371527,37.6989062 87.3371527,37.6989062 L80.9961101,30.7619065 Z",
    id: "Path",
    fill: "#FFD7D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.17407599,24.470934 C8.14058683,38.3921197 19.0654169,63.9658349 23.5692236,71.5956356 C29.2134437,81.1507597 38.1136268,85.3605343 48.5343611,78.2710877 C59.4839828,70.8216822 89.6341056,41.7667798 90.5183392,35.1852662 C91.3943089,28.6037526 84.0146771,20.7071001 77.3374738,24.7955028 C70.6602705,28.8839054 42.9149326,52.1112961 42.9149326,52.1112961 C42.9149326,52.1112961 31.7173949,23.2364326 22.7097816,6.50956182 C14.9086926,-7.96195381 -6.90791213,3.30733996 2.17407599,24.470934 Z",
    id: "Path",
    fill: "#675CD7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.0306267,52.1262597 C45.0355861,58.9672578 46.2724113,62.1897083 46.7411023,61.7936112 C47.2097933,61.3975141 47.0307429,57.2811239 46.203951,49.4444405 L43.0306267,52.1262597 Z",
    id: "Path",
    fillOpacity: 0.302802666,
    fill: "#000000"
  })), /*#__PURE__*/React.createElement("g", {
    id: "PhoneMini4",
    transform: "translate(191.388041, 99.402033) scale(-1, 1) rotate(-18.000000) translate(-191.388041, -99.402033) translate(177.888041, 74.902033)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.15143635,0.755699735 L21.9668732,0.755699735 C23.2923566,0.755699735 24.3668732,1.83021634 24.3668732,3.15569974 L24.3668732,45.8681997 C24.3668732,47.1936831 23.2923566,48.2681997 21.9668732,48.2681997 L3.15143635,48.2681997 C1.82595295,48.2681997 0.75143635,47.1936831 0.75143635,45.8681997 L0.75143635,3.15569974 C0.75143635,1.83021634 1.82595295,0.755699735 3.15143635,0.755699735 Z",
    id: "Rectangle",
    fill: "#7596FF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#93C2F9",
    x: 2.53022538,
    y: 0.13125,
    width: 23.6154369,
    height: 47.5125
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.7513161,1.828125 L8.54234149,1.828125 C8.90721684,1.828125 9.21068291,2.09261712 9.27361518,2.44140876 L9.28558991,2.57580523 C9.28558991,2.98873762 9.61835356,3.32348546 10.0288383,3.32348546 L18.6651298,3.32348546 C19.0300051,3.32348546 19.3334712,3.05899334 19.3964035,2.7102017 L19.4083782,2.57580523 C19.4083782,2.16287284 19.7411419,1.828125 20.1516266,1.828125 L21.9336118,1.828125 C23.2573561,1.828125 24.3429949,2.85365524 24.4482494,4.15801114 L24.4566121,4.36841492 L24.4566121,4.36841492 L24.4226446,43.0055543 C24.4184761,44.6913812 23.0595263,46.0572257 21.3836889,46.0599321 L7.21442681,46.0599321 C5.61044903,46.0625108 4.29696391,44.81146 4.1857799,43.226384 L4.17815636,43.0082532 C4.17815636,43.0073528 4.17815636,43.0064524 4.18084158,43.0055543 L4.21480103,4.37750907 C4.21603917,2.96915857 5.35131293,1.828125 6.7513161,1.828125 Z",
    id: "Rectangle",
    fill: "#E6F3FF",
    fillRule: "nonzero"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Body",
    transform: "translate(33.240443, 73.153607)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,14.1833231 C0,14.1833231 14.3783022,62.6155161 14.8041247,71.7833638 C15.2299471,80.952123 3.04417741,107.898796 5.11892927,114.709744 C9.90263663,130.44884 70.9764459,137.226066 73.309821,116.053159 C74.3980325,106.178793 72.133387,97.3164441 74.742682,85.6814163 C77.3429168,74.0463885 87.7947696,56.7565748 81.8666282,40.5011252 C75.9384867,24.2456755 77.5268633,9.20685718 73.2867591,6.36435837 C69.0466548,3.52185955 59.1349582,0.503096924 59.1349582,0.503096924 C54.3150106,7.63850601 38.0431576,7.53460556 30.2786931,-8.0380147e-14 C30.2786931,-8.0380147e-14 10.9898428,3.76411285 0,14.1833231 Z",
    id: "Path",
    fill: "#7367F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8847346,22.0274344 C22.468959,37.3281161 22.4401447,63.9680381 27.5875634,67.4569528 C32.7349821,70.9458674 52.7692241,67.5220793 52.7692241,70.2850778 C52.7692241,73.0480762 25.0831621,98.3693917 29.6282199,110.474165 C32.0080965,116.812449 31.3625385,122.482822 27.6915458,127.485282 L26.4932778,127.222606 C15.5847441,124.742612 6.81477047,120.289309 5.11892927,114.709744 C3.04417741,107.898796 16.6356279,80.952123 16.2098054,71.7833638 C15.8483381,64.0010656 4.4201194,27.9257471 0.974050476,17.1992743 C3.77969602,12.2198765 7.74924451,13.8289098 12.8847346,22.0274344 Z",
    id: "Path",
    fillOpacity: 0.199355332,
    fill: "#000000"
  })), /*#__PURE__*/React.createElement("g", {
    id: "RArm",
    transform: "translate(0.000000, 83.288281)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.4684532,52.4863331 C62.4684532,52.4863331 74.5791944,41.7036869 78.2865641,40.4523742 C81.9939339,39.2010615 103.70722,37.6978434 103.56991,40.5253902 C103.414292,43.5546439 91.7520972,43.3803181 90.5437693,44.8707584 C89.3354414,46.3602859 89.0608214,56.5460259 84.4929757,57.6896399 C79.934284,58.8332539 66.267363,60.8046875 66.267363,60.8046875 L62.4684532,52.4863331 Z",
    id: "Path",
    fill: "#FFD7D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.2491076,6.83199437 C17.4896994,24.9471596 6.59603034,52.5409736 2.41451443,63.2990092 C-1.76700148,74.0570448 2.45111155,90.2835833 20.8382122,87.0979877 C39.1922573,83.9207052 68.3951105,66.6568001 71.6262819,61.6206993 C74.8574532,56.5845986 69.9487172,47.4209047 63.7673458,48.6204909 C58.0404871,49.7302952 29.6340399,61.8809006 29.6340399,61.8809006 C29.6340399,61.8809006 47.908988,29.2949323 52.3714754,20.5594839 C59.825482,5.97075297 41.4879646,-9.1292361 30.2491076,6.83199437 Z",
    id: "Path",
    fill: "#675CD7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9232752,61.6581085 C23.5420883,64.8473308 20.7406379,65.7731771 21.518924,64.4356476 C22.2972102,63.0981181 26.3162034,60.0798541 33.5759037,55.3808558 L29.9232752,61.6581085 Z",
    id: "Path",
    fillOpacity: 0.302802666,
    fill: "#000000"
  })), /*#__PURE__*/React.createElement("g", {
    id: "RLeg",
    transform: "translate(30.924977, 181.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M158.258044,138.352397 C158.258044,138.352397 158.03574,155.986564 172.48015,162.579716 C186.915471,169.171953 197.20017,168.775084 195.891173,173.872203 C194.582177,178.968408 157.008391,178.762661 153.499553,174.776593 C150.50886,171.385829 144.005434,139.81094 142.214655,142.225076 L158.258044,138.352397 Z",
    id: "Path",
    fill: "#FFD7D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.829906,158.091617 C148.44295,154.956467 148.544351,163.776245 154.90673,161.832483 C160.069993,160.255062 161.834985,151.227578 165.097688,153.20469 C168.360391,155.181802 197.079523,170.512658 197.243147,170.605017 C200.779255,172.52078 199.791015,178.325553 193.818719,179.338758 C187.182835,180.463526 152.798698,179.706368 150.953377,177.926857 C149.108056,176.147347 145.536417,160.605671 146.829906,158.091617 Z",
    id: "Path",
    fill: "#2B2E35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.345688,158.477491 C168.773097,158.477491 168.220319,159.030157 167.687352,160.135489 C167.447434,160.632966 167.656271,161.230727 168.153766,161.470607 C168.170764,161.478804 168.187991,161.486517 168.205426,161.493739 L183.556485,167.852019 C183.930735,168.007006 184.361522,167.920927 184.647458,167.634004 C185.164503,167.115176 185.350003,166.702461 185.203958,166.39586 C184.923811,165.807729 170.427689,158.477491 169.345688,158.477491 Z",
    id: "Path-14",
    fillOpacity: 0.54097465,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.29067187,0.249526065 C-4.14076904,26.659934 -1.62138442,44.3995325 15.8488257,53.4683214 C41.1915262,66.6237213 117.058938,51.0644151 117.058938,51.0644151 C117.058938,51.0644151 115.703253,62.0443151 117.058938,71.8370626 C120.599654,97.4133107 137.438973,140.024647 141.001755,145.378865 C145.928672,152.78313 160.937043,147.199167 161.219746,141.033955 C161.50245,134.868742 149.905672,56.128593 148.142163,41.113398 C146.387745,26.0972885 140.848845,23.9161441 124.671133,19.8113901 C120.954529,18.8683802 77.003412,7.88068782 72.9771123,8.20094625 C49.9135862,10.0354567 28.3514394,7.38498327 8.29067187,0.249526065 Z",
    id: "Path",
    fill: "#42474F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.7321149,49.3798701 C53.8222348,52.2079951 120.247291,46.3784403 122.91507,49.027397 C125.462067,51.5564239 125.037107,95.5558318 130.750608,121.022305 L129.881683,118.61748 C124.508353,103.604449 118.928935,85.3449313 117.058938,71.8370626 C115.703253,62.0443151 117.058938,51.0644151 117.058938,51.0644151 L113.999871,51.6600716 C99.5783148,54.3851568 38.1504022,65.0450733 15.8488257,53.4683214 C3.76506829,47.1956409 -1.16594134,36.774687 1.05579684,22.2054595 C4.88151849,38.6728355 14.1069338,47.7313391 28.7321149,49.3798701 Z",
    id: "Path",
    fill: "#52565E"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#52565E",
    transform: "translate(158.841927, 43.128906) rotate(13.000000) translate(-158.841927, -43.128906) ",
    cx: 158.841927,
    cy: 43.1289062,
    rx: 4.21831169,
    ry: 7.77501048
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#52565E",
    transform: "translate(139.162396, 38.179687) rotate(-16.000000) translate(-139.162396, -38.179687) ",
    cx: 139.162396,
    cy: 38.1796875,
    rx: 5.62526636,
    ry: 8.48055296
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M168.11136,236 L293,236 L293,236 L293,356.2528 C293,357.217752 292.217752,358 291.2528,358 L144,358 L144,358 L144,260.11136 C144,246.795024 154.795024,236 168.11136,236 Z",
    id: "Rectangle",
    fill: "#374057"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-37",
    transform: "translate(39.000000, 20.000000) scale(-1, 1) translate(-39.000000, -20.000000) translate(13.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4,0 L7.11483415,0 C8.66560855,1.047395e-15 9.92275958,1.25715104 9.92275958,2.80792543 L9.92275958,4.39657406 C9.92275958,5.06996204 10.4686484,5.61585086 11.1420364,5.61585086 L41.0666667,5.61585086 C43.2758057,5.61585086 45.0666667,7.40671186 45.0666667,9.61585086 L45.0666667,34.2608696 C45.0666667,36.4700086 43.2758057,38.2608696 41.0666667,38.2608696 L4,38.2608696 C1.790861,38.2608696 -1.73547709e-16,36.4700086 0,34.2608696 L0,4 C-2.705415e-16,1.790861 1.790861,4.05812251e-16 4,0 Z",
    id: "Rectangle",
    fill: "url(#linearGradient-1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6877372,3.47826087 L45.3750253,3.47826087 C46.0484133,3.47826087 46.5943021,4.02414969 46.5943021,4.69753767 C46.5943021,4.76067447 46.5893981,4.82371589 46.5796343,4.88609316 L41.5168718,37.2301483 C41.4239933,37.8235129 40.9128525,38.2608696 40.3122628,38.2608696 L6.62497467,38.2608696 C5.95158668,38.2608696 5.40569787,37.7149807 5.40569787,37.0415928 C5.40569787,36.978456 5.41060189,36.9154145 5.42036571,36.8530373 L10.4831282,4.50898218 C10.5760067,3.91561754 11.0871475,3.47826087 11.6877372,3.47826087 Z",
    id: "Rectangle",
    fill: "url(#linearGradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.078254,16.934303 L47.8666432,33.52078 C47.1382074,37.2828126 43.8444281,40 40.0125215,40 L4.84880692,40 C2.63966792,40 0.848806915,38.209139 0.848806915,36 C0.848806915,35.7447902 0.873231302,35.4901661 0.921746044,35.23961 L4.13335677,18.6531331 C4.86179262,14.8911004 8.15557186,12.173913 11.9874785,12.173913 L47.1511931,12.173913 C49.3603321,12.173913 51.1511931,13.964774 51.1511931,16.173913 C51.1511931,16.4291228 51.1267687,16.6837469 51.078254,16.934303 Z",
    id: "Rectangle",
    fill: "#FFCC7B"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-79",
    transform: "translate(314.000000, 213.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-86"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.4643416,101.599979 C52.472864,76.7500315 62.4739465,51.2286809 71.6295823,25.143887 C50.540359,44.977898 34.1407521,69.1415442 36.4760411,101.599979 L41.4643416,101.599979 Z",
    id: "Path-113",
    fill: "#57E295"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.5968751,104.19494 C32.9913656,61.8227302 34.0954396,22.4707967 55.9333743,0 C52.9211671,46.5225002 47.2864561,79.2955302 40.1499709,104.19494 L35.5968751,104.19494 Z",
    id: "Rectangle",
    fill: "#28C76F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5949186,99.7824121 C22.3941279,70.1725746 10.1341672,61.6849684 4.24620339e-14,31.2909454 C33.1666701,48.4518513 35.245737,62.6222972 41.7558449,99.7824121 L34.5949186,99.7824121 Z",
    id: "Path-112",
    fill: "#57E295"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0284394,99.7824121 L6.14107222,70.1725746 C16.7117587,73.179246 34.3803908,78.0480079 34.3803908,99.7824121 L28.0284394,99.7824121 Z",
    id: "Path-114",
    fill: "#28C76F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.4994792,99.7824121 L55.8010896,99.7824121 C60.4411086,90.1150089 66.9798231,83.4598078 82.7987093,91.5272157 C72.4295535,75.7671194 51.1541858,70.9975405 48.4994792,99.7824121 Z",
    id: "Path-116",
    fill: "#57E295"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.7830823,99.7824121 L47.8549511,99.7824121 C58.9986539,83.8806059 63.7898942,76.9517141 75.3221231,63.371933 C60.1302655,69.124124 44.5362323,76.9517141 41.7830823,99.7824121 Z",
    id: "Path-117",
    fill: "#28C76F"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-85",
    transform: "translate(12.769231, 97.375000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Rectangle",
    fill: "#7367F0",
    xlinkHref: "#path-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-7.40383374,-1.70607435 L20.0961202,-1.70607435 C6.93056438,28.7145423 32.9003962,46.7297232 20.0961202,77.0358187 L-7.40383374,77.0358187 L-7.40383374,-1.70607435 Z",
    id: "Rectangle",
    fill: "#857AF9",
    mask: "url(#mask-4)"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwoFactorAuthenticationIllustrationDark);
export default __webpack_public_path__ + "static/media/two-factor-authentication-illustration-dark.b1796a7d2783b860a0903dd797ff006d.svg";
export { ForwardRef as ReactComponent };